<section class="hero wave-bg" style="padding-bottom: 0;">
  <div class="container hero-content">
    <h1>
      News & 
      <span class="accent"> Recommandations</span>
    </h1>
    <p class="hero-description" style="margin-bottom: 2rem;">
      Retrouvez nos derniers conseils techniques et actualités du secteur pour piloter votre croissance numérique.
    </p>
  </div>
</section>

<section class="section" style="padding-top: 0;">
  <div class="container">
    <div class="grid-2">
      <a *ngFor="let item of ressources" [routerLink]="['/ressources', item.id]" class="card reveal" style="text-decoration: none; color: inherit; display: flex; flex-direction: column;">
        <div style="margin-bottom: 1rem; color: var(--brand); font-weight: bold; font-size: 0.85rem; text-transform: uppercase;">
          {{ item.type }} • {{ formatDate(item.date) }}
        </div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.excerpt }}</p>
        <span style="margin-top: auto; color: var(--brand); font-weight: 600;">Lire la suite →</span>
      </a>
    </div>
  </div>
</section>

<section class="section cta-final alt">
  <div class="container">
    <h2>Un besoin spécifique ?</h2>
    <p>Nos recommandations sont générales, mais votre projet est unique. Discutons de vos enjeux techniques.</p>
    <a 
      href="https://cal.mesh-box.fr/ogirodin/30min"
      class="button primary large" 
      data-cal-link="ogirodin/30min" 
      data-cal-config='{"layout":"month_view"}'
    >
      Prendre rendez-vous
    </a>
  </div>
</section>